import { createInitializeStoresFunction, createGetStoreFunction } from './helpers';
import { ObjectStore, CollectionStore } from '@utils/orm';

const PROFILE_STORE_KEYS = {
  configStore: 'profileConfigStore',
  groupsStore: 'profileGroupsStore',
  groupScoresStore: 'profileGroupScoresStore',
  groupSortOrder: 'profileGroupSortOrder',
  appInvitesStore: 'profileAppInvitesStore',
  groupCollectionStore: 'profileGroupCollectionStore',
  groupCollectionSortOrderStore: 'profileGroupCollectionSortOrderStore',
  followCountStore: 'profileFollowCountStore',
  followModalStore: 'profileFollowModalStore',
  linktreePromptStore: 'profileLinktreePromptStore',
};

const PROFILE_STORE_TYPES = {
  configStore: ObjectStore,
  groupsStore: CollectionStore,
  groupScoresStore: ObjectStore,
  groupSortOrder: CollectionStore,
  appInvitesStore: CollectionStore,
  groupCollectionStore: CollectionStore,
  groupCollectionSortOrderStore: CollectionStore,
  followCountStore: ObjectStore,
  followModalStore: CollectionStore,
  linktreePromptStore: ObjectStore,
};

export const initializeProfileStores = createInitializeStoresFunction(PROFILE_STORE_KEYS, PROFILE_STORE_TYPES);
export const getProfileStore = createGetStoreFunction(PROFILE_STORE_KEYS, PROFILE_STORE_TYPES);
